import { requestPartnerUrl, redirectToPaymentPage, scrollTo, calculateDesiredPositionInsideFrameFromTopSoModalCanBeInsideViewport, subscribeScrollHappenedNotifyFor } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';
import { PARTNER_HOST_URL, CALCULATED_DESIRED_MODAL_POSITION, RESPONSE_SCROLL_HAPPENED_NOTIFY_FOR } from '@PROJECT_ROOT/assets/shared/js/partnerToFrameMessageTypes';
import { getMessageDataAsObject } from '@PROJECT_ROOT/assets/shared/js/partnerMessaging';
import { reportPageLeaveFrameHTMLElement } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import screenService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/screenService';
import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';

export const IS_FRAME_SERVICE = windowManipulationService.isBrowserEnvironment()
    && [ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST,
        ADRIATIC_PARTNER_SCHEME_HOST,
        ADRIATIC_PARTNER_MOBILE_SCHEME_HOST]
        .some((h) => window.location.href.startsWith(h));

export const setWindowParentLocation = (location) => {
    window.parent.location = location;
};

export const setScrollTop = (topFromBeginingOfFrame) => {
    window.parent.postMessage(scrollTo(topFromBeginingOfFrame), '*');
};

const didPageLeaveFrameHTMLElement = () => {
    const itIndeadLeave = window.top === window.self;
    if (itIndeadLeave) {
        reportPageLeaveFrameHTMLElement();
    }

    return itIndeadLeave;
};

export const getDesiredPositionInsideFrameFromTopSoModalCanBeInsideViewport = async (offsetTop = 100) => {
    if (!IS_FRAME_SERVICE) {
        throw Error('Funkcija namjenjena za FRAME servis.');
    }
    const timeout = 2000;
    if (didPageLeaveFrameHTMLElement()) {
        return window.top;
    }
    // TODO first scroll to up or down only if frame is not taking max visibility
    return new Promise((resolve) => {
        const cleanup = () => {
            // eslint-disable-next-line no-use-before-define
            window.removeEventListener('message', handleMessage);
        };
        const handleMessage = ({ data }) => {
            const parsedData = getMessageDataAsObject(data);
            if (typeof parsedData.type === 'undefined') {
                return;
            }
            if (parsedData.type === CALCULATED_DESIRED_MODAL_POSITION && typeof parsedData.calculatedModalRect === 'object') {
                const { viewportHeight, top, bottom } = parsedData.calculatedModalRect;
                const topMin0 = top < 0 ? 0 : top;
                const bottomPreliminaryOffset = -bottom - viewportHeight - 2;
                const calculatedModalBottomOffset = bottomPreliminaryOffset > 0 ? bottomPreliminaryOffset : 0;
                const modals = document.querySelectorAll('.modal-control-container');
                modals.forEach((modal) => {
                    const modalControlTop = topMin0 + offsetTop;
                    const frameHeight = window.innerHeight;
                    if (modal.parentElement.id !== 'reservationMobileModal') {
                        modal.style.top = `${modalControlTop}px`;
                    }
                    modal.style.bottom = `${calculatedModalBottomOffset}px`;
                    modal.style.height = `${frameHeight - calculatedModalBottomOffset - modalControlTop}px`;
                });
                const searchMaps = document.querySelectorAll('#searchResultsReact .searchResultsMap');
                const pageContentElements = document.querySelectorAll('#searchResultsReact .pageContent');
                const distanceFromTopToSearchResultsReact = 90;
                const distanceTopToPageContent = pageContentElements[0] ? pageContentElements[0].getBoundingClientRect().top + distanceFromTopToSearchResultsReact : 0;
                searchMaps.forEach((searchMap) => {
                    searchMap.style.top = `${topMin0}px`;
                    searchMap.style.bottom = `${calculatedModalBottomOffset - (screenService.isDesktopView() ? 0 : distanceTopToPageContent)}px`;
                });
                const searchMapsCloseBtns = document.querySelectorAll('#searchResultsReact .search-results__map-map-and-filters-buttons');
                const searchMapCloseBtnTopMarginOnDesktopBecauseOfSearchHeader = 90;
                searchMapsCloseBtns.forEach((searchMapsCloseBtn) => {
                    searchMapsCloseBtn.style.top = `${
                        topMin0 > searchMapCloseBtnTopMarginOnDesktopBecauseOfSearchHeader
                            ? topMin0 + 15 : topMin0 + searchMapCloseBtnTopMarginOnDesktopBecauseOfSearchHeader
                    }px`;
                });
                const facilityMap = document.querySelector('modal__controlsWrapper');
                if (facilityMap !== null) {
                    facilityMap.style.top = `${topMin0 + offsetTop}px`;
                    facilityMap.style.bottom = `${calculatedModalBottomOffset}px`;
                }
                window.dispatchEvent(new Event('resize')); // Kako bi se mapa trigerala da rekalkulira veličinu
                resolve(parsedData.calculatedModalRect);
                cleanup();
            }
        };
        window.addEventListener('message', handleMessage);
        setTimeout(() => {
            cleanup();
            resolve(undefined);
        }, timeout);
        window.parent.postMessage(calculateDesiredPositionInsideFrameFromTopSoModalCanBeInsideViewport(), '*');
    });
};

export const redirectOutsideOfFrameToPaymentPage = (paymentUrl) => {
    window.parent.postMessage(redirectToPaymentPage(paymentUrl), '*');
};

export const getOutsideOfFrameURL = async (timeout = 3000) => {
    if (didPageLeaveFrameHTMLElement()) {
        return null;
    }
    const frameMessagePasscode = Math.random();
    return new Promise((resolve) => {
        const cleanup = () => {
            // eslint-disable-next-line no-use-before-define
            window.removeEventListener('message', handleMessage);
        };
        const handleMessage = (event) => {
            const parsedData = getMessageDataAsObject(event.data);
            if (typeof parsedData.type === 'undefined') {
                return;
            }
            if (frameMessagePasscode !== parsedData.frameMessagePasscode) {
                throw Error('Pokusaj komunikacije iz nedozvoljene browser kartice. Vjerojatno pokušaj hakiranja.');
            }
            if (parsedData.type === PARTNER_HOST_URL && typeof parsedData.url === 'string') {
                resolve(parsedData.url);
                cleanup();
            }
        };
        window.addEventListener('message', handleMessage);
        setTimeout(() => {
            cleanup();
            resolve(undefined);
        }, timeout);
        window.parent.postMessage(requestPartnerUrl(frameMessagePasscode), '*');
    });
};

const mapSelectorSubscribedForOnScrollMessage = new Map();
const subscribeForOneScrollMessageFor = (notifyIdentifier) => {
    const handleMessage = (event) => {
        const parsedData = getMessageDataAsObject(event.data);
        if (typeof parsedData.type === 'undefined') {
            return;
        }
        if (parsedData.type === RESPONSE_SCROLL_HAPPENED_NOTIFY_FOR
            && parsedData.notifyIdentifier === notifyIdentifier
            && typeof parsedData.calculatedModalRect === 'object') {
            const el = document.querySelector(notifyIdentifier);
            if (!el) return;
            el.style.top = `${parsedData.calculatedModalRect.top + 20}px`;
        }
    };
    window.addEventListener('message', handleMessage);
    window.parent.postMessage(subscribeScrollHappenedNotifyFor(notifyIdentifier), '*');
};

export const keepStickyVisibleForSelectorOnDesktop = (selector) => {
    if (windowManipulationService.isBrowserEnvironment() && IS_FRAME_SERVICE && screenService.isDesktopView()) {
        if (!mapSelectorSubscribedForOnScrollMessage.has(selector)) {
            subscribeForOneScrollMessageFor(selector);
            mapSelectorSubscribedForOnScrollMessage.set(selector, true);
        }
    }
};
